import { render, staticRenderFns } from "./adriftPublish.vue?vue&type=template&id=481da9cb&scoped=true&"
import script from "./adriftPublish.vue?vue&type=script&lang=js&"
export * from "./adriftPublish.vue?vue&type=script&lang=js&"
import style0 from "./adriftPublish.vue?vue&type=style&index=0&id=481da9cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481da9cb",
  null
  
)

export default component.exports